import React from "react";
import { Link } from "react-router-dom";
const Footer1 = () => {
  return (
    <footer className="footer-section" >
      <div className="container">
        <div className="row">
          <div className="col-lg-4 col-md-4">
            <div className="footer-content">
              <h5>
                <img
                  src="./assets/image/nos-services-icon.png"
                  alt="footer-img"
                />
                Nos réseaux sociaux
              </h5>
            </div>
          </div>
          <div className="col-lg-8 col-md-8">
            <div className="footer-content">
              <ul>
                <li>
                  <div>
                    <Link
                      to={"https://www.facebook.com/BeatimoSC"}
                      target="_blank"
                    >
                      <span>01</span>
                    </Link>
                    <Link
                      to={"https://www.facebook.com/BeatimoSC"}
                      target="_blank"
                    >
                      <p>Facebook</p>
                    </Link>
                  </div>
                  <Link
                    to={"https://www.facebook.com/BeatimoSC"}
                    target="_blank"
                  >
                    <svg
                      width={47}
                      height={47}
                      viewBox="0 0 47 47"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <rect
                        x="45.5"
                        y="45.5"
                        width="44.5"
                        height="44.5"
                        rx="22.25"
                        transform="rotate(-180 45.5 45.5)"
                        stroke="#FFFAE6"
                        strokeWidth={2}
                      />
                      <path
                        d="M20.7219 31.8265H24.3334V24.5945H27.5874L27.9449 21.001H24.3334V19.1863C24.3334 18.9468 24.4285 18.7172 24.5978 18.5478C24.7672 18.3785 24.9968 18.2834 25.2363 18.2834H27.9449V14.6719H25.2363C24.039 14.6719 22.8907 15.1475 22.0441 15.9941C21.1975 16.8407 20.7219 17.989 20.7219 19.1863V21.001H18.9161L18.5586 24.5945H20.7219V31.8265Z"
                        fill="#FFFAE6"
                      />
                    </svg>
                  </Link>
                </li>
                <li>
                  <div>
                    <Link
                      to={"https://www.youtube.com/@Beatimo"}
                      target="_blank"
                    >
                      <span>02</span>
                    </Link>
                    <Link
                      to={"https://www.youtube.com/@Beatimo"}
                      target="_blank"
                    >
                      <p>Youtube</p>
                    </Link>
                  </div>
                  <Link to={"https://www.youtube.com/@Beatimo"} target="_blank">
                    <svg
                      width={47}
                      height={47}
                      viewBox="0 0 47 47"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <rect
                        x="45.5"
                        y="45.5"
                        width="44.5"
                        height="44.5"
                        rx="22.25"
                        transform="rotate(-180 45.5 45.5)"
                        stroke="#FFFAE6"
                        strokeWidth={2}
                      />
                      <path
                        d="M31.4042 18.7939C31.3074 18.4018 31.1183 18.0443 30.8558 17.7568C30.5932 17.4693 30.2663 17.262 29.9075 17.1554C28.5774 16.7565 23.2559 16.75 23.2559 16.75C23.2559 16.75 17.9352 16.7435 16.6042 17.1248C16.2457 17.2363 15.9195 17.4466 15.6568 17.7354C15.3941 18.0243 15.2038 18.3821 15.1042 18.7744C14.7534 20.2273 14.75 23.2407 14.75 23.2407C14.75 23.2407 14.7466 26.269 15.0949 27.707C15.2902 28.5021 15.8636 29.1302 16.5923 29.3446C17.9361 29.7435 23.2431 29.75 23.2431 29.75C23.2431 29.75 28.5646 29.7565 29.8948 29.3761C30.2537 29.2697 30.5809 29.0629 30.8441 28.776C31.1074 28.4891 31.2975 28.1322 31.3957 27.7404C31.7473 26.2885 31.7499 23.276 31.7499 23.276C31.7499 23.276 31.7669 20.2468 31.4042 18.7939ZM21.5537 26.0324L21.5579 20.4657L25.9808 23.2537L21.5537 26.0324Z"
                        fill="#FFFAE6"
                      />
                    </svg>
                  </Link>
                </li>
                <li>
                  <div>
                    <Link
                      to={"https://www.linkedin.com/company/beatimo-services-conseils"}
                      target="_blank"
                    >
                      <span>03</span>
                    </Link>
                    <Link
                      to={"https://www.linkedin.com/company/beatimo-services-conseils"}
                      target="_blank"
                    >
                      <p>LinkedIn</p>
                    </Link>
                  </div>
                  <Link to={"https://www.linkedin.com/company/beatimo-services-conseils"} target="_blank">
                    <svg
                      width={47}
                      height={47}
                      viewBox="0 0 47 47"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <rect
                        x="45.5"
                        y="45.5"
                        width="44.5"
                        height="44.5"
                        rx="22.25"
                        transform="rotate(-180 45.5 45.5)"
                        stroke="#FFFAE6"
                        strokeWidth={2}
                      />
                      <path
                        d="M18.6091 31.75V20.2801H14.965V31.75H18.6091ZM16.7875 18.7132C18.0583 18.7132 18.8493 17.8324 18.8493 16.7318C18.8256 15.6063 18.0584 14.75 16.8117 14.75C15.5651 14.75 14.75 15.6063 14.75 16.7318C14.75 17.8325 15.5408 18.7132 16.7637 18.7132H16.7874H16.7875ZM20.6261 31.75H24.2703V25.3447C24.2703 25.0019 24.294 24.6594 24.3902 24.4144C24.6536 23.7294 25.2532 23.0201 26.2599 23.0201C27.5786 23.0201 28.1061 24.0719 28.1061 25.6138V31.7499H31.75V25.1732C31.75 21.6501 29.9522 20.0108 27.5546 20.0108C25.5887 20.0108 24.7256 21.1604 24.246 21.9434H24.2704V20.2799H20.6262C20.6741 21.3562 20.6262 31.7498 20.6262 31.7498L20.6261 31.75Z"
                        fill="#FFFAE6"
                      />
                    </svg>
                  </Link>
                </li>
                <li>
                  <div>
                    <Link
                      to={"https://www.instagram.com/beatimoservicesconseils/"}
                      target="_blank"
                    >
                      <span>04</span>
                    </Link>
                    <Link
                      to={"https://www.instagram.com/beatimoservicesconseils/"}
                      target="_blank"
                    >
                      <p>Instagram</p>
                    </Link>
                  </div>
                  <Link to={"https://www.instagram.com/beatimoservicesconseils/"} target="_blank">
                    
                    <svg  width={47}
                      height={47}
                      viewBox="0 0 47 47"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg">
                      <rect
                        x="45.5"
                        y="45.5"
                        width="44.5"
                        height="44.5"
                        rx="22.25"
                        transform="rotate(-180 45.5 45.5)"
                        stroke="#FFFAE6"
                        strokeWidth={2}
                      />
                      <path d="M23.4979 18.8203C22.6371 18.8201 21.7955 19.0753 21.0797 19.5535C20.3639 20.0317 19.806 20.7114 19.4767 21.5067C19.1473 22.3021 19.0612 23.1772 19.2293 24.0215C19.3974 24.8658 19.8122 25.6412 20.4211 26.2497C21.03 26.8582 21.8057 27.2724 22.6501 27.4399C23.4944 27.6075 24.3695 27.5208 25.1646 27.1909C25.9598 26.861 26.6391 26.3026 27.1168 25.5865C27.5946 24.8704 27.8491 24.0287 27.8484 23.1678C27.8487 22.5965 27.7365 22.0308 27.5179 21.503C27.2994 20.9751 26.9789 20.4956 26.5748 20.0918C26.1707 19.688 25.691 19.3678 25.163 19.1496C24.635 18.9314 24.0692 18.8195 23.4979 18.8203V18.8203ZM23.4979 26.0005C22.9386 26.0005 22.3918 25.8347 21.9267 25.5241C21.4616 25.2134 21.099 24.7718 20.8848 24.2552C20.6706 23.7385 20.6143 23.1699 20.7232 22.6213C20.832 22.0727 21.101 21.5686 21.4963 21.1728C21.8915 20.7771 22.3952 20.5073 22.9437 20.3978C23.4921 20.2882 24.0608 20.3436 24.5777 20.5571C25.0947 20.7706 25.5368 21.1326 25.8481 21.5973C26.1594 22.062 26.326 22.6085 26.3267 23.1678C26.3254 23.9177 26.027 24.6364 25.4968 25.1667C24.9665 25.6969 24.2478 25.9953 23.4979 25.9966V26.0005ZM29.042 18.6431C29.0418 18.8436 28.9821 19.0396 28.8706 19.2063C28.7591 19.373 28.6006 19.5028 28.4153 19.5795C28.23 19.6562 28.0261 19.6762 27.8294 19.637C27.6327 19.5978 27.4521 19.5012 27.3102 19.3594C27.1684 19.2176 27.0718 19.0369 27.0327 18.8403C26.9935 18.6436 27.0135 18.4397 27.0902 18.2544C27.1668 18.069 27.2967 17.9106 27.4634 17.7991C27.63 17.6875 27.826 17.6279 28.0266 17.6277C28.1599 17.6274 28.2919 17.6535 28.4151 17.7044C28.5383 17.7553 28.6502 17.83 28.7444 17.9242C28.8387 18.0185 28.9134 18.1304 28.9643 18.2536C29.0152 18.3768 29.0412 18.5088 29.041 18.6421L29.042 18.6431ZM31.9237 19.6722C31.9512 18.3533 31.4588 17.0766 30.5528 16.1178C29.5916 15.2144 28.3154 14.7225 26.9965 14.747C25.5953 14.6677 21.3957 14.6677 19.9945 14.747C18.6754 14.7217 17.3989 15.2138 16.4381 16.1178C15.5332 17.0781 15.041 18.3549 15.0673 19.6742C14.988 21.0753 14.988 25.275 15.0673 26.6762C15.0392 27.9957 15.5316 29.2732 16.4381 30.2325C17.3997 31.1353 18.6757 31.6271 19.9945 31.6033C21.3957 31.6826 25.5953 31.6826 26.9965 31.6033C28.316 31.6314 29.5936 31.139 30.5528 30.2325C31.4562 29.2713 31.9482 27.9951 31.9237 26.6762C32.003 25.275 32.003 21.0793 31.9237 19.6781V19.6722ZM30.1132 28.1733C29.9692 28.5385 29.7516 28.8702 29.474 29.1478C29.1964 29.4254 28.8647 29.643 28.4995 29.787C27.3823 30.2296 24.7317 30.1277 23.4969 30.1277C22.2622 30.1277 19.6077 30.2257 18.4944 29.787C18.1292 29.643 17.7975 29.4254 17.5199 29.1478C17.2423 28.8702 17.0247 28.5385 16.8807 28.1733C16.4381 27.0561 16.54 24.4055 16.54 23.1708C16.54 21.936 16.442 19.2815 16.8807 18.1682C17.025 17.8031 17.2427 17.4715 17.5205 17.1941C17.7982 16.9167 18.1301 16.6993 18.4954 16.5555C19.6155 16.1129 22.2593 16.2157 23.4979 16.2157C24.7366 16.2157 27.3872 16.1178 28.5005 16.5565C28.8657 16.7005 29.1974 16.9181 29.475 17.1957C29.7526 17.4733 29.9701 17.8049 30.1142 18.1702C30.5567 19.2874 30.4549 21.938 30.4549 23.1727C30.4549 24.4074 30.5558 27.06 30.1132 28.1743V28.1733Z" fill="white"/>
                    </svg>

                  </Link>
                </li>
                {/* <li>
                  <div>
                    <Link
                      to={"/services-conseils"}
                    >
                      <span>04</span>
                    </Link>
                    <Link
                      to={"/services-conseils"}
                    >
                      <p>Tiktok</p>
                    </Link>
                  </div>
                  <Link to={"/services-conseils"} >
                    <svg
                      width={47}
                      height={47}
                      viewBox="0 0 47 47"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <rect
                        x="45.5"
                        y="45.5"
                        width="44.5"
                        height="44.5"
                        rx="22.25"
                        transform="rotate(-180 45.5 45.5)"
                        stroke="#FFFAE6"
                        strokeWidth={2}
                      />
                      <path
                        d="M29.855 18.7377C28.9972 18.5513 28.2212 18.1012 27.6384 17.452C27.0555 16.8028 26.6958 15.9878 26.6108 15.1241V14.75H23.6419V26.3729C23.6425 26.8886 23.4789 27.3914 23.1742 27.8102C22.8695 28.2289 22.4391 28.5423 21.9442 28.7059C21.4492 28.8696 20.9146 28.8752 20.4162 28.722C19.9178 28.5688 19.4808 28.2645 19.1671 27.8523C18.8861 27.4874 18.7141 27.0521 18.6704 26.5956C18.6267 26.1391 18.7132 25.6797 18.92 25.2692C19.1268 24.8588 19.4457 24.5137 19.8407 24.273C20.2357 24.0323 20.6909 23.9055 21.155 23.9071C21.4116 23.9057 21.667 23.943 21.9123 24.0177V21.0418C21.6268 21.0069 21.3392 20.9927 21.0517 20.9993C19.9927 21.0273 18.9648 21.3598 18.0941 21.9561C17.2234 22.5524 16.5476 23.3866 16.1494 24.3566C15.7512 25.3266 15.6479 26.3903 15.8523 27.4174C16.0566 28.4446 16.5596 29.3905 17.2998 30.1395C18.0583 30.9014 19.029 31.4234 20.0885 31.6391C21.148 31.8548 22.2485 31.7544 23.2501 31.3507C24.2517 30.947 25.1093 30.2582 25.7138 29.3719C26.3183 28.4856 26.6425 27.4417 26.6452 26.3729V20.4211C27.8426 21.2662 29.2785 21.7183 30.75 21.7135V18.8227C30.4609 18.8239 30.1726 18.7954 29.8895 18.7377H29.855Z"
                        fill="#FFFAE6"
                      />
                    </svg>
                  </Link>
                </li> */}
              </ul>
            </div>
          </div>
          <div className="col-lg-12">
            <div className="footer-logo">
              <img
                src="./assets/image/footer-logo.png"
                className="img-fluid"
                alt="footer-img"
              />
            </div>
          </div>
          <div className="col-lg-12">
            <div className="footer-bottom">
              <div>
                <p>
                  <Link className="text-light" to="">
                    {" "}
                    Copyright © 2024 beatimo | Tout droits réservés{" "}
                  </Link>
                </p>
                <p>
                  <Link className="text-light" to="">
                    {" "}
                    Préférence des témoins{" "}
                  </Link>
                </p>
                <p>
                  <Link className="text-light" to="/conseils-terms&condition">
                    {" "}
                    Politiques et confidentialité{" "}
                  </Link>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer1;
